<script setup>
import { API_PATHS } from "@/utils/apiPaths";
import axiosInstance from "@/utils/axiosInstance";
import { CalendarRange, CalendarRangeIcon, Funnel } from "lucide-vue-next";
import { onMounted, ref } from "vue";
import LineChart from "../Charts/LineChart.vue";
import DonutCharts from "../Charts/DonutCharts.vue";
import RecentActivity from "../RecentActivity.vue";
import BarChart from "../Charts/BarChart.vue";
import DashKpi from "../ui/DashKpi.vue";
import Loading from "../Loading.vue";
import { useLocationStore } from "@/store/useLocation";

const start_month = ref("");
const end_month = ref("");
const year = ref("");
const kpi = ref({});
const loading = ref(false);
const useLocation = useLocationStore();

const getDashboardStats = async () => {
  try {
    loading.value = true;

    const [resp] = await Promise.all([
      axiosInstance.get(API_PATHS.DASHBOARD.RESUM_INFO),
    ]);
    kpi.value = resp.data;
  } catch (error) {
    console.log(error);
  } finally {
    loading.value = false;
  }
};

const getCoutries = async () => {
  if (!useLocation.location) {
    const location = await axiosInstance.get(API_PATHS.LOCATION.locations);
    useLocation.setLocation(location.data);
  }
};

onMounted(() => {
  getDashboardStats();
  getCoutries();
});
</script>

<template>
  <div class="mb-40">
    <div class="grid grid-cols-1 md:grid-cols-12 p-4">
      <div className="col-span-12 md:col-span-12 p-4 space-y-6 ">
        <div class="flex justify-between items-center p-4 shadow rounded-2xl">
          <h4 class="text-orange-600 font-bold text-[24px]">Dashboard</h4>

          <div
            class="group size-10 overflow-hidden w-[250px] h-[60px] flex bg-white shadow-3xl hover:bg-red-300 px-3 py-3 justify-between gap-x-2 cursor-pointer items-center rounded-xl"
          >
            <CalendarRangeIcon class="w-5 h-5" />
            <div class="flex flex-col leading-tight space-y-0">
              <p
                class="group-hover:text-white uppercase text-red-300 font-bold text-[14px]"
              >
                Alterar Periodo
              </p>
              <span
                class="group-hover:text-white text-[12px] text-gray-400 font-bold"
                >{{ start_month }} - {{ end_month }} {{ year }}</span
              >
            </div>
            <div>
              <Funnel
                className="text-orange-300 group-hover:text-white w-5
              h-5"
              />
            </div>
          </div>
        </div>
        <div class="flex flex-row gap-3">
          <DashKpi :stats="kpi || {}" />
        </div>
      </div>
      <!-- Graficos -->
      <div class="col-span-12 grid grid-cols-1 mb-3 p-4">
        <div
          class="bg-white rounded-2xl shadow p-2 flex items-center justify-center h-[40vh]"
        >
          <LineChart
            :title="'Evolução dos pagamentos mensais'"
            :data="kpi?.totalPaidByMonth || []"
          />
        </div>
      </div>
      <div class="col-span-12 grid grid-cols-2 gap-6 mb-3 p-4">
        <div
          class="bg-white rounded-2xl shadow p-2 flex items-center justify-center h-[40vh]"
        >
          <BarChart :data="kpi?.studentByCourseLevel" />
        </div>

        <div
          class="bg-white rounded-2xl shadow p-2 flex items-center justify-center h-[40vh]"
        >
          <DonutCharts
            :data="kpi?.totalByStatus"
            title="Evolução de pagamentos mensais por status"
          />
        </div>
      </div>

      <div class="col-span-12 grid grid-cols-2 gap-6 p-4">
        <div
          class="bg-white rounded-2xl shadow h-[60vh] overflow-x-hidden[scrollbar-width:_thin]"
        >
          <RecentActivity :activities="kpi?.recentActivities || []" />
        </div>
      </div>
    </div>
    <Loading :loadingData="loading" />
  </div>
</template>
